/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: 'Không có dữ liệu được tìm thấy.',
  DocumentIndex: 'Mục lục tài liệu',
  SubmissionIndex: 'chỉ mục gửi',
  Search: 'Tìm kiếm',
  Searching: 'Đang tìm kiếm...',
  Filter: 'Lọc',
  FullTextSearch_SentenceCase: 'Tìm kiếm trong tài liệu',
  BulkDownload_SentenceCase: 'Tải xuống hàng loạt',
  ExportToExcel: 'Xuất sang Excel',
  ExpandAll_SentenceCase: 'Mở rộng tất cả',
  CollapseAll_SentenceCase: 'Thu gọn tất cả',
  BulkDownloadName_SentenceCase: 'Tên gói hàng',
  SelectAll_SentenceCase: 'Chọn tất cả',
  AskQuestion: 'Đặt một câu hỏi',
  Move: 'Di chuyển',
  Edit: 'Biên tập',
  OpenInOfficeOnline: 'Mở trong Microsoft Office cho web',
  EditInOfficeOnline: 'Chỉnh sửa trong Microsoft Office cho web',
  Security: 'Bảo mật',
  Enable: 'Kích hoạt',
  Disable: 'Vô hiệu hóa',
  Delete: 'Xóa bỏ',
  History: 'Lịch sử',
  History_LowerCase: 'lịch sử',
  ManageDocuments: 'Quản lý tài liệu',
  SelectDocumentsToRedact: 'Chọn tài liệu để biên tập lại',
  Submissions: 'bài nộp',
  TenderSubmissions: 'Nộp hồ sơ dự thầu',
  Add: 'Thêm vào',
  Folder: 'Thư mục',
  Document: 'Tài liệu',
  Document_LowerCase: 'tài liệu',
  Documents_LowerCase: 'các tài liệu',
  Folder_LowerCase: 'thư mục',
  Folders_LowerCase: 'thư mục',
  Renumber: 'Đánh số lại',
  BulkUpload_SentenceCase: 'Tải lên hàng loạt',
  BulkDownloadOverDownloadLimit:
    'Bạn đã đạt đến giới hạn kích thước tải xuống là 100 GB. Vui lòng xóa tệp khỏi lựa chọn để tiếp tục.',
  Name_: 'Tên:',
  Number_: 'Con số:',
  Retry: 'Thử lại',
  FolderNotDeletedAccess:
    'LỖI: Không thể xóa thư mục vì nó chứa một hoặc nhiều tài liệu và/hoặc thư mục con mà bạn không được phép truy cập.',
  FolderNotDeleted: 'LỖI: Không thể xóa Thư mục.',
  DocumentNotDeleted: 'LỖI: Không thể xóa Tài liệu.',
  FolderNotUpdated: 'LỖI: Không thể cập nhật Thư mục.',
  DocumentNotUpdated: 'LỖI: Không thể cập nhật Tài liệu.',
  ParentFolderDisabled: 'Thư mục mẹ bị vô hiệu hóa',
  EnableDocument:
    'Thư mục này chứa 1 tài liệu, bạn có chắc chắn muốn kích hoạt thư mục này không?',
  EnableDocuments: '\u003cb\u003eEnable\u003c/b\u003e Tài liệu',
  EnableFolder:
    'Thư mục này chứa 1 thư mục, bạn có chắc chắn muốn kích hoạt thư mục này không?',
  EnableFolderDocument:
    'Thư mục này chứa 1 thư mục và 1 tài liệu, bạn có chắc chắn muốn kích hoạt thư mục này không?',
  EnableFolderDocuments:
    'Thư mục này chứa 1 thư mục và các tài liệu ${NumberOfDocuments}, bạn có chắc chắn muốn kích hoạt thư mục này không?',
  EnableFolders:
    'Thư mục này chứa các thư mục ${NumberOfFolders}, bạn có chắc chắn muốn bật thư mục này không?',
  EnableFoldersDocument:
    'Thư mục này chứa các thư mục ${NumberOfFolders} và 1 tài liệu, bạn có chắc chắn muốn kích hoạt thư mục này không?',
  EnableFoldersDocuments:
    'Thư mục này chứa các thư mục ${NumberOfFolders} và các tài liệu ${NumberOfDocuments}, bạn có chắc chắn muốn bật thư mục này không?',
  BulkEnableFolders: 'Các thư mục ${NumberOfFolders} sẽ được bật.',
  BulkEnableFoldersWithImplicitFolders:
    'Để kích hoạt các mục này tất cả các thư mục mẹ phải được kích hoạt. Các thư mục ${NumberOfFolders} sẽ được bật.',
  BulkEnableOneFolder: '1 thư mục sẽ được kích hoạt.',
  BulkEnableOneFolderAndDocuments:
    '1 thư mục và các tài liệu ${NumberOfDocuments} sẽ được kích hoạt.',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    'Để kích hoạt các mục này tất cả các thư mục mẹ phải được kích hoạt. 1 thư mục và các tài liệu ${NumberOfDocuments} sẽ được kích hoạt.',
  BulkEnableOneFolderAndOneDocument:
    '1 thư mục và 1 tài liệu sẽ được kích hoạt.',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    'Để kích hoạt các mục này tất cả các thư mục mẹ phải được kích hoạt. 1 thư mục và 1 tài liệu sẽ được kích hoạt.',
  BulkEnableDocuments: 'Tài liệu ${NumberOfDocuments} sẽ được bật.',
  BulkEnableOneDocument: '1 tài liệu sẽ được kích hoạt.',
  BulkEnableFoldersAndOneDocument:
    'Các thư mục ${NumberOfFolders} và 1 tài liệu sẽ được bật.',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    'Để kích hoạt các mục này tất cả các thư mục mẹ phải được kích hoạt. Các thư mục ${NumberOfFolders} và 1 tài liệu sẽ được bật.',
  BulkEnableFoldersAndDocuments:
    'Các thư mục ${NumberOfFolders} và các tài liệu ${NumberOfDocuments} sẽ được kích hoạt.',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    'Để kích hoạt các mục này tất cả các thư mục mẹ phải được kích hoạt. Các thư mục ${NumberOfFolders} và các tài liệu ${NumberOfDocuments} sẽ được kích hoạt.',
  BulkEnableDocumentsErrorMessage:
    'LỖI: Không thể bật (các) tài liệu ${NumberOfDocuments}.',
  BulkEnableFoldersErrorMessage:
    'LỖI: Không thể bật (các) thư mục ${NumberOfFolders}.',
  BulkEnableFoldersDocumentsErrorMessage:
    'LỖI: Không thể bật (các) thư mục ${NumberOfFolders} và (các) tài liệu ${NumberOfDocuments}.',
  DisableDocument:
    'Thư mục này chứa 1 tài liệu, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableDocuments: '\u003cb\u003eTắt\u003c/b\u003e Tài liệu',
  DisableFolder:
    'Thư mục này chứa 1 thư mục, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableFolderDocument:
    'Thư mục này chứa 1 thư mục và 1 tài liệu, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableFolderDocuments:
    'Thư mục này chứa 1 thư mục và các tài liệu ${NumberOfDocuments}, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableFolders:
    'Thư mục này chứa các thư mục ${NumberOfFolders}, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableFoldersDocument:
    'Thư mục này chứa các thư mục ${NumberOfFolders} và 1 tài liệu, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableFoldersDocuments:
    'Thư mục này chứa các thư mục ${NumberOfFolders} và các tài liệu ${NumberOfDocuments}, bạn có chắc chắn muốn tắt thư mục này không?',
  DisableFolderConfirm:
    'Thư mục &quot;${FolderName}&quot; chứa các thư mục khác bên trong, chúng cũng sẽ bị vô hiệu hóa.',
  BulkDisableFolders: 'Các thư mục ${NumberOfFolders} sẽ bị vô hiệu hóa.',
  BulkDisableOneFolder: '1 thư mục sẽ bị vô hiệu hóa.',
  BulkDisableOneFolderAndDocuments:
    '1 thư mục và các tài liệu ${NumberOfDocuments} sẽ bị vô hiệu hóa.',
  BulkDisableOneFolderAndOneDocument:
    '1 thư mục và 1 tài liệu sẽ bị vô hiệu hóa.',
  BulkDisableDocuments: 'Tài liệu ${NumberOfDocuments} sẽ bị vô hiệu hóa.',
  BulkDisableOneDocument: '1 tài liệu sẽ bị vô hiệu hóa.',
  BulkDisableFoldersAndOneDocument:
    'Các thư mục ${NumberOfFolders} và 1 tài liệu sẽ bị vô hiệu hóa.',
  BulkDisableFoldersAndDocuments:
    'Các thư mục ${NumberOfFolders} và các tài liệu ${NumberOfDocuments} sẽ bị vô hiệu hóa.',
  BulkDisableDocumentsErrorMessage:
    'LỖI: Không thể tắt (các) tài liệu ${NumberOfDocuments}.',
  BulkDisableFoldersErrorMessage:
    'LỖI: Không thể tắt (các) thư mục ${NumberOfFolders}.',
  BulkDisableFoldersDocumentsErrorMessage:
    'LỖI: Không thể tắt (các) thư mục ${NumberOfFolders} và (các) tài liệu ${NumberOfDocuments}.',
  DeleteFileConfirmation: '&quot;${FileName}&quot; sẽ bị xóa ngay lập tức.',
  DeleteFolderConfirmation: '&quot;${FolderName}&quot; sẽ bị xóa ngay lập tức.',
  BulkDeleteFolders: 'Các thư mục ${NumberOfFolders} sẽ bị xóa.',
  BulkDeleteOneFolder: '1 thư mục sẽ bị xóa.',
  BulkDeleteOneFolderAndDocuments:
    '1 thư mục và các tài liệu ${NumberOfDocuments} sẽ bị xóa.',
  BulkDeleteOneFolderAndOneDocument: '1 thư mục và 1 tài liệu sẽ bị xóa.',
  BulkDeleteDocuments: 'Tài liệu ${NumberOfDocuments} sẽ bị xóa.',
  BulkDeleteOneDocument: '1 tài liệu sẽ bị xóa.',
  BulkDeleteFoldersAndOneDocument:
    'Các thư mục ${NumberOfFolders} và 1 tài liệu sẽ bị xóa.',
  BulkDeleteFoldersAndDocuments:
    'Các thư mục ${NumberOfFolders} và các tài liệu ${NumberOfDocuments} sẽ bị xóa.',
  BulkDeleteDocumentsErrorMessage:
    'LỖI: Không thể xóa (các) tài liệu ${NumberOfDocuments}.',
  BulkDeleteFoldersErrorMessage:
    'LỖI: Không thể xóa (các) thư mục ${NumberOfFolders}.',
  BulkDeleteFoldersDocumentsErrorMessage:
    'LỖI: Không thể xóa (các) thư mục ${NumberOfFolders} và (các) tài liệu ${NumberOfDocuments}.',
  AddFolder: 'Thêm thư mục',
  AddDocument: 'Thêm tài liệu',
  CopyLink_SentenceCase: 'Sao chép đường dẫn',
  SendToKira_SentenceCase: 'Gửi tới Kira',
  Actions: 'Hành động',
  Download: 'Tải xuống',
  DownloadPart: 'Tải xuống phần ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    'Tải xuống hàng loạt chưa được bật. Liên hệ với Quản trị viên để biết thêm thông tin',
  Disabled: 'Tàn tật',
  FileTypeUnknown: 'Tài liệu',
  FileTypeAcrobat: 'Acrobat PDF',
  FileTypeArchive: 'Lưu trữ',
  FileTypeAudio: 'Tập tin âm thanh',
  FileTypeCode: 'Mã số',
  FileTypeContact: 'Liên hệ',
  FileTypeEmail: 'E-mail',
  FileTypeExcel: 'Excel',
  FileTypeImage: 'Hình ảnh',
  FileTypeLayoutAndDesign: 'Thiết kế văn bản',
  FileTypePowerpoint: 'Powerpoint',
  FileTypeText: 'Chữ',
  FileTypeVideo: 'Băng hình',
  FileTypeVisio: 'Visio',
  FileTypeWord: 'Từ',
  SavingAllowed: 'Cho phép lưu',
  SavingDenied: 'Lưu bị từ chối',
  PrintingAllowed: 'Cho phép in ấn',
  PrintingDenied: 'Việc in bị từ chối',
  FileExtensionEmpty: 'Không gia hạn',
  OneBulkDownloadInProgress: 'Đang tải xuống hàng loạt 1 - ${progress}%',
  NumberOfBulkDownloadInProgress:
    '${number} đang tải xuống hàng loạt - ${progress}%',
  Cancel: 'Hủy bỏ',
  Expand: 'Mở rộng',
  Collapse: 'Sụp đổ',
  FolderEmpty: 'Thư mục trống',
  UseChromeToBulkUpload:
    'Sử dụng Chrome để tải lên hàng loạt tài liệu và thư mục.',
  RenumberCallToAction: 'Đánh số lại',
  Archives: 'Lưu trữ',
  BulkDownloadUnavailable:
    'Tải xuống hàng loạt hiện không có sẵn. Vui lòng thử lại sau',
  PreviewNotAvailable: 'Tính năng xem trước không khả dụng',
  DocumentIsTooLargeToPreview:
    'Tài liệu này quá lớn để xem trước. Bạn cần tải tài liệu xuống để xem.',
  DocumentIsTooLargeToPreviewWithoutDownload:
    'Tài liệu này quá lớn để xem trước',
  FileCannotBePreviewed: 'Không thể xem trước tập tin này.',
  OwnerHasSecuredThisDocument: 'Chủ sở hữu đã bảo đảm tài liệu này',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    'Tài liệu này được bảo mật bằng Adobe Rights Management. Bạn cần Adobe Acrobat Reader và trực tuyến để xem tài liệu này.',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    'Tài liệu này được bảo mật bằng Microsoft Rights Management. Bạn cần Microsoft Office và trực tuyến để xem tài liệu này.',
  SecuredPdfHelpLink:
    'Tìm hiểu thêm về \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003cxem PDF tài liệu.\u003c/a\u003e',
  SecuredPdfHelpLinkMac:
    'Tìm hiểu thêm về \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003cxem PDF tài liệu.\u003c/a\u003e',
  SecuredDocHelpLink:
    'Tìm hiểu thêm về lớp học \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 =\u0022ace-helplink\u0022\u003cxem lại tài liệu Office.\u003c/a\u003e',
  YourDownloadIsBeingPrepared:
    'Quá trình tải xuống của bạn đang được chuẩn bị...',
  OwnerHasSecuredTheseDocuments: 'Chủ sở hữu đã bảo đảm các tài liệu này',
  SecuredPdfAndDocHelpLink:
    'Tìm hiểu thêm về \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003cxem PDF tài liệu\u003c/a\u003e hoặc \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target= \u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eTài liệu Office.\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    'Tìm hiểu thêm về \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003cxem PDF tài liệu\u003c/a\u003e hoặc \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target= \u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eTài liệu Office.\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    'Các tài liệu này được bảo mật bằng Adobe Rights Management hoặc Microsoft Rights Management. Bạn cần Adobe Acrobat Reader hoặc Microsoft Office và trực tuyến để xem các tài liệu này.',
  UnableToDownloadThisFileTryAgain: 'Không thể tải xuống tập tin này.',
  DownloadStarted: 'Đã bắt đầu tải xuống',
  Close: 'Đóng',
  GotIt: 'Hiểu rồi',
  Preview: 'Xem trước',
  DontShowThisAgain: 'Đừng hiển thị lại thông tin này',
  BulkDownloadPrepareTitle: 'Quá trình tải xuống của bạn đang được chuẩn bị...',
  BulkDownloadPrepareAwareMessage:
    'Xin lưu ý rằng tệp tải xuống càng lớn thì thời gian xử lý càng lâu.',
  BulkDownloadPrepareMessage:
    'Một email sẽ được gửi tới <strong>${email}</strong> khi quá trình tải xuống của bạn đã sẵn sàng.',
  BulkDownloadLimitError:
    'Bạn đã đạt đến giới hạn tải xuống của tệp ${limitedNumberOfItems} hoặc ${limitedFileSize}. Vui lòng xóa tệp khỏi lựa chọn để tiếp tục.',
  LinkCopiedToClipboard: 'Liên kết được sao chép vào khay nhớ tạm',
  RestoreDocuments: 'Khôi phục tài liệu',
  RepairNumbering: 'Sửa chữa đánh số',
  BulkUpdate: 'Cập nhật hàng loạt',
  GenerateFolders: 'Tạo thư mục',
  NotificationsReport: 'Báo cáo thông báo',
  DownloadHelpInfo:
    'Nếu quá trình tải xuống không bắt đầu sau vài giây, vui lòng sử dụng',
  DirectLink: 'đương dân trực tiêp',
  YourDocumentsAreDownloading: 'Tài liệu của bạn đang tải xuống.',
  DocumentRenamed: 'Tài liệu đã được đổi tên.',
  FolderRenamed: 'Thư mục đã được đổi tên.',
  FolderRenamedRenumber: 'Đánh số lại để cập nhật nội dung thư mục',
  DocumentsNotificationList: 'Danh sách thông báo tài liệu',
  UserDocumentNotificationSettings: 'Cài đặt thông báo tài liệu người dùng',
  IntervalType: 'Loại khoảng thời gian',
  NumberOfUsers: 'Số lượng người dùng',
  NotificationList: 'Danh sách thông báo',
  ExportSelectedItemsToExcel: 'Xuất [Số] sang Excel',
  ToEmail: 'Đến thư điện tử',
  FromSentDateSydneyTime: 'Từ Ngày Gửi (Giờ Sydney)',
  ToSentDateSydneyTime: 'Đến ngày gửi (Giờ Sydney)',
  DocID: 'ID tài liệu',
  DocName: 'Tên tài liệu',
  To: 'ĐẾN',
  UserType: 'Loại người dùng',
  SentDateSydneyTime: 'Ngày gửi (Giờ Sydney)',
  Previous: 'Trước',
  Next: 'Kế tiếp',
  DisableFolderConfirmHeader: 'Bạn sắp vô hiệu hóa một thư mục',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    'Hiện tại không có tài liệu hoặc thư mục nào có sẵn.',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    'Không có tài liệu hoặc thư mục nào phù hợp với tiêu chí lọc.',
  DeleteFolderConfirmHeader: 'Bạn sắp xóa một thư mục',
  DeleteFileConfirmHeader: 'Bạn sắp xóa một tập tin',
  MoveItemDialogUseDestinationFolderSecurity:
    'Sử dụng cài đặt bảo mật thư mục từ ${destinationFolderName}',
  MoveItemDialogSecuritySettingsLabel: 'Cài đặt hệ thống bảo vệ',
  MoveItemDialogUseCurrentFolderSecurity: 'Sử dụng cài đặt bảo mật hiện tại',
  MoveItemDialogNotifyCheckbox:
    'Thông báo cho mọi người khi quyền truy cập được cấp',
  MoveItemNewLocation: 'Vị trí mới:',
  DontHavePermissionToMoveFolder: 'Bạn không có quyền di chuyển thư mục này.',
  DontHavePermissionToMoveFolders:
    'Bạn không có quyền di chuyển các thư mục này.',
  DontHavePermissionToMoveItemsMoveIntoFolder:
    'Bạn không có quyền di chuyển các mục vào thư mục này.',
  SecuredFileIsTooLargeToPreview:
    'Tệp bạn đang cố xem trước quá lớn. Bạn có thể tải xuống thay thế.',
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    'Tệp bạn đang cố xem trước quá lớn.',
  BeforeYouDownload: 'Trước khi bạn tải xuống',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eTìm hiểu thêm về cách xem PDF tài liệu.\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eTìm hiểu thêm về cách xem PDF tài liệu.\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace -helplink\u0022\u003eTìm hiểu thêm về cách xem tài liệu Office.\u003c/a\u003e',
  StartYourDataRoomAndAddDocument:
    'Bắt đầu phòng dữ liệu của bạn và thêm tài liệu.',
  UploadDocuments: 'Tải lên Tài liệu',
  ExpiredDocumentAccess:
    'Quyền truy cập của bạn vào tài liệu này đã hết hạn. Liên hệ với quản trị viên phòng dữ liệu để có quyền truy cập.',
  MultipleDragDropInfo: 'Chọn, kéo và thả tài liệu, thư mục để di chuyển',
  DemoMultipleDragDropTitle: 'Làm thế nào nó hoạt động',
  Zipping: 'Nén',
  Processing: 'Xử lý...',
  YourFilesAreReadyToDownload: 'Tệp của bạn đã sẵn sàng để tải xuống',
  ThisBulkDownloadIsSplit:
    'Bản tải xuống này quá lớn và chúng tôi đã chia nó thành nhiều phần. Những liên kết này cũng có thể được tìm thấy trong email của bạn.',
  BulkDownloadEmptyFoldersNote: 'Các thư mục trống sẽ không được tải xuống.',
  NotifyPeopleWhenAccessIsGranted:
    'Thông báo cho mọi người khi quyền truy cập được cấp',
  BulkEnableConfirmHeader: 'Kích hoạt thư mục và tài liệu',
  BulkDisableConfirmHeader: 'Vô hiệu hóa thư mục và tài liệu',
  CopyDocumentsInProgress: 'Đang tải chỉ mục tài liệu',
  SomeDocumentsAreSecuredLink:
    'Một số tài liệu được bảo mật bởi Quản trị viên. Để mở chúng, bạn cần:',
  EnableTruncation: 'Kích hoạt tính năng cắt ngắn',
  OptimizeFilePathForWindows: 'Tối ưu đường dẫn file cho Windows',
  TruncationNoteForWindows:
    'Với người dùng Windows thì cần sử dụng 7-Zip trên Windows 10 để giải nén.',
  Restore: 'Khôi phục',
  Current: 'Hiện hành',
  AddedBy: 'Được thêm bởi',
  UpdatedBy: 'Cập nhật',
  RestoreThisVersion: 'Khôi phục phiên bản này',
  AdobeAcrobatReader: 'Adobe Acrobat Reader',
  MicrosoftOffice: 'Microsoft Office',
  InternetConnection: 'kết nối Internet',
  BulkDeleteConfirmHeader: 'Xóa thư mục và tài liệu',
  Preparing: 'Chuẩn bị...',
  SomeSavingDeniedFilesSelected:
    'Tài liệu ${number} có chính sách &quot;Lưu bị từ chối&quot; và sẽ không được tải xuống.',
  RestoreDocumentSuccessMessage: '${title} đã được khôi phục',
  RestoreVersionNumberButtonText: 'Khôi phục phiên bản ${versionNumber}',
  HistoryDialogNothingChangeMessage:
    'Phiên bản này giống với phiên bản hiện tại',
  HistoryDialogNoDocumentChangeMessage: 'Nội dung tài liệu không bị thay đổi',
  HistoryDialogNoNameAndNumberChangeMessage: 'Tên và số văn bản không thay đổi',
  ResetViewAsToDownload:
    'Đặt lại bộ lọc &quot;Xem dưới dạng&quot; để tải xuống.',
  NoPermissionToDownloadTooltip:
    'Quản trị viên đã tắt tính năng tải xuống hàng loạt cho phòng này',
  Remove: 'Di dời',
  Reset: 'Cài lại',
  ResetNow: 'Đặt lại ngay bây giờ',
  ResetDialogTitle: 'Đặt lại quy trình gửi',
  ResetDialogContent:
    'Bạn có chắc chắn muốn thiết lập lại quá trình gửi không? Ngày và giờ kết thúc sẽ được đặt lại.',
  Confirm: 'Xác nhận',
  Region: 'Vùng đất',
  KiraSuccessfullyConnectedTitle: 'Đã kết nối thành công với Kira',
  KiraSuccessfullyConnectedFirstLine:
    'Bây giờ bạn có thể gửi tài liệu tới Kira để khám phá',
  KiraSuccessfullyConnectedSecondLine:
    'thông tin liên quan từ hợp đồng và các tài liệu liên quan.',
  KiraProjectsLoading: 'Đang tải dự án...',
  KiraSelectProject: 'Chọn một dự án ở Kira...',
  KiraSendDocument: 'Gửi tài liệu cho Kira',
  KiraConnect: 'Kết nối với Kira',
  KiraCompanyUrl: 'URL công ty Kira của bạn',
  KiraApiToken: 'Mã thông báo API Kira',
  KiraUnableToConnect:
    'Chúng tôi không thể kết nối với Kira. Vui lòng xác minh khu vực và mã thông báo của bạn rồi thử lại.',
  KiraConfigError: 'Đã xảy ra lỗi khi tải cấu hình. Vui lòng thử lại.',
  KiraProjectsLoadError:
    'Chúng tôi không thể tìm nạp dự án của bạn từ Kira. Vui lòng thử lại.',
  KiraSendDocumentError:
    'Đã xảy ra lỗi khi chuyển tài liệu tới Kira. Vui lòng thử lại.',
  KiraSendingDocument: 'Đang gửi &#39;${documentName}&#39; tới Kira',
  KiraDocumentSent: '&#39;${documentName}&#39; đã gửi tới Kira',
  Redact: 'Biên tập',
  RedactDocuments: 'Biên tập lại tài liệu',
  EditRedact: 'Chỉnh sửa biên tập',
  RedactionIsNotAvailable: 'Việc chỉnh sửa không có sẵn',
  RedactGetDocumentError:
    'Chúng tôi không thể lấy được tài liệu này. Vui lòng thử lại',
  RedactBurnDocumentError:
    'Chúng tôi không thể biên tập lại tài liệu này. Vui lòng thử lại',
  RedactFileTooLarge:
    'Các tệp lớn hơn ${fileSize} hiện không được hỗ trợ để biên tập. Tối ưu hóa kích thước tài liệu và thử lại.',
  RedactSaveDialogTitle: 'Lưu dưới dạng tài liệu được biên tập lại mới',
  MultipleDocumentsErrorDescription:
    '${numberOfDocuments} tài liệu được đánh dấu không thể xử lý được. Bạn có thể thử và tải tài liệu lên lại.',
  SingleDocumentErrorDescription:
    '1 tài liệu được đánh dấu là không thể xử lý được. Bạn có thể thử và tải tài liệu lên lại.',
  MultipleDocumentsInProgressDescription:
    '${numberOfDocuments} Tài liệu được đánh dấu chưa xử lý xong.',
  SingleDocumentInProgressDescription:
    '1 tài liệu được đánh dấu chưa xử lý xong.',
  CancelBulkRedaction: 'Hủy chỉnh sửa hàng loạt',
  CancelBulkRedactionMessage:
    'Bạn sắp dừng quá trình biên tập.' +
    'Việc dừng biên tập sẽ ngừng biên tập tài liệu hiện tại và đưa bạn trở lại chỉ mục tài liệu.',
  StopRedaction: 'Dừng biên tập',
  DocumentLocation: 'Vị trí tài liệu',
  SecurityControls: 'Cài đặt bảo mật',
  SecuritySettings: 'Cài đặt hệ thống bảo vệ',
  UseFolderSecurityFrom: 'Sử dụng cài đặt bảo mật thư mục từ',
  UseSecurityFromOpenedDocument: 'Sử dụng cài đặt bảo mật từ tài liệu đã mở',
  UseSecurityFromOriginalDocument: 'Sử dụng cài đặt bảo mật từ tài liệu gốc',
  UseSecurityFromOriginalFolder: 'Sử dụng cài đặt bảo mật từ thư mục gốc',
  UseSecurityFromOriginalFoldersAndDocuments:
    'Sử dụng cài đặt bảo mật từ các thư mục gốc và tài liệu gốc',
  DocumentWillBeDisabledByDefault: 'Tài liệu sẽ bị tắt theo mặc định.',
  DocumentsAndFoldersWillBeDisabledByDefault:
    'Các thư mục và tài liệu sẽ bị tắt theo mặc định.',
  ImportDataRoomError:
    'Nhập bằng trackId ${trackingId} bị lỗi. Vui lòng thử lại.',
  RedactionError: 'Không thể loại bỏ ${fileName}, vui lòng thử lại.',
  RedactionHowRedactionSavingWorks:
    'Cách hoạt động của tính năng lưu lại việc chỉnh sửa',
  RedactionEducationDialogForAdministrators: 'Dành cho quản trị viên',
  RedactionEducationDialogForGuests: 'Cho khách',
  RedactionEducationDialogPreviewDownload: 'Xem trước/Tải xuống',
  RedactionEducationDialogEditing: 'Chỉnh sửa',
  RedactionEducationDialog1Layer: 'tài liệu 1 lớp',
  RedactionEducationDialog2Layer: 'tài liệu 2 lớp',
  RedactionEducationDialogRedactionsAreBakedIn:
    'Các giao dịch được thực hiện sẵn',
  RedactionEducationDialogRedactionsAreEditable:
    'Các bản chỉnh sửa có thể chỉnh sửa được',
  RedactionSaveAsNewDocument: 'Lưu dưới dạng tài liệu mới',
  RedactionHowSavingWorks: 'Cách tiết kiệm hoạt động',
  ChangesYouMadedWillNotBeSaved:
    'Những thay đổi bạn đã thực hiện sẽ không được lưu.',
  IsRedacted: 'được biên tập lại.',
  DocumentsAddedFrom: 'Tài liệu được thêm từ ${dataroomName}.',
  GoToFile: 'Cho tôi xem tài liệu',
  GoToImportFolder: 'Cho tôi xem thư mục',
  Thanks: 'Cảm ơn',
  Validation_DuplicatedDocumentInFolder:
    'Tài liệu ${documentName} đã tồn tại trong ${folderName}',
  Validation_NameCannotBeEmpty: 'Tên không được để trống.',
  Continue: 'Tiếp tục',
  RedactingMessage:
    'Việc chỉnh sửa lại có thể mất một thời gian. Vui lòng không làm mới',
  Name: 'Tên',
  Number: 'Con số',
  LearnMore: 'Tìm hiểu thêm',
  BulkActionsNoItemsWillBeAffected:
    'Không có mục nào sẽ bị ảnh hưởng bởi hoạt động này.',
  Saving: 'Tiết kiệm',
  YouCanKeepWorking: 'Bạn có thể tiếp tục làm việc.',
  Copy: 'Sao chép',
  CopyDocument: 'Sao chép tài liệu vào',
  CopyFolder: 'Sao chép thư mục vào',
  Import: 'Nhập khẩu',
  DataRooms: 'Phòng dữ liệu',
  Accept: 'Chấp nhận',
  TermOfAccess: 'Điều khoản truy cập',
  TermOfAccessCheckbox: 'Tôi đã đọc, hiểu và đồng ý với các điều khoản',
  ImportingDataFrom: 'Thêm tài liệu từ ${dataroomName}.',
  Refresh: 'Làm cho khỏe lại',
  ImportTo: 'Nhập vào',
  ImportError: 'Lỗi nhập, vui lòng liên hệ với quản trị viên.',
  Back: 'Mặt sau',
  LastAccessed: 'Đã truy cập',
  NeverAccessed: 'Chưa bao giờ truy cập',
  Remaining: 'còn lại',
  SubmissionWindowIsOpen: 'Cửa sổ gửi bài đang mở.',
  SubmissionWindowHasEnd:
    'Cửa sổ gửi đã kết thúc. Tài liệu bạn tải lên bây giờ sẽ bị đánh dấu là muộn.',
  FromYourComputer: 'Từ máy tính của bạn',
  FromAnotherDataRoom: 'Từ một phòng dữ liệu khác',
  FromFolderStructure: 'Từ cấu trúc thư mục',
  FromDataRoom: 'Từ phòng dữ liệu',
  AddFromDataRoom: 'Thêm từ phòng dữ liệu',
  AddFromFolderStructure: 'Thêm từ cấu trúc thư mục',
  ImportDialogDataRoomScreenDialogTitle: 'Thêm tài liệu từ phòng dữ liệu',
  ImportDialogDataRoomScreenHeading:
    'Chọn Phòng dữ liệu chứa tài liệu bạn muốn thêm.',
  ImportDialogTermOfAccessScreenDialogTitle: 'Thêm tài liệu từ ${dataroomName}',
  ImportDialogTermOfAccessScreenHeading:
    'Bạn cần chấp nhận Điều khoản truy cập trước khi có thể thêm tài liệu từ phòng dữ liệu này.',
  ImportDialogDataRoomScreenRadioBtn: 'Thêm tài liệu từ phòng dữ liệu này',
  ImportDialogDocumentListScreenHeading:
    'Chọn một hoặc nhiều tài liệu để thêm vào phòng dữ liệu của bạn.',
  ImportDialogEmptyDataRoom: 'Không có phòng dữ liệu mà bạn có thể truy cập.',
  ImportDialogEmptyDocument:
    'Không có tài liệu nào để thêm từ phòng dữ liệu này.',
  ImportDialogDocumentListScreenDialogTitle: 'Thêm tài liệu từ ${dataroomName}',
  UserTypeCode_ADM: 'Người quản lý',
  UserTypeCode_DOP: 'Nhà xuất bản',
  UserTypeCode_GUE: 'Khách mời',
  UserTypeCode_USQ: 'Trình xem hạn chế',
  UserTypeCode_USR: 'Người xem',
  QnaRoleCode_QVW: 'Trình xem câu hỏi',
  QnaRoleCode_BAP: 'Người phê duyệt nhà thầu',
  QnaRoleCode_BAA: 'tác giả nhà thầu',
  QnaRoleCode_BMC: 'Người liên hệ chính của nhà thầu',
  QnaRoleCode_IAP: 'Người phê duyệt nội bộ',
  QnaRoleCode_IAA: 'Tác giả nội bộ',
  QnaRoleCode_IMC: 'Liên hệ chính nội bộ',
  QnaRoleCode_IOB: 'Người quan sát nội bộ',
  QnaRoleCode_QAU: 'Tác giả câu hỏi',
  QnaRoleCode_QAP: 'Người phê duyệt câu hỏi',
  QnaRoleCode_ADR: 'Người soạn thảo câu trả lời',
  QnaRoleCode_AAU: 'Trả lời tác giả',
  QnaRoleCode_AAP: 'Người phê duyệt câu trả lời',
  QnaRoleCode_QAA: 'Quản trị viên hỏi đáp',
  QnaRoleCode_QAO: 'Kiểm soát hoàn toàn người quan sát hỏi đáp',
  QnaRoleCode_QOV: 'Chỉ xem phần hỏi đáp của người quan sát',
  DemoRoom: '*DEMO* - ${dataroomName}',
  SearchDocuments_InputPlaceholder:
    'Nhập từ khóa hoặc tên và số của tài liệu hoặc thư mục',
  SearchDocuments_Find: 'Tìm thấy',
  SearchDocuments_Results: 'Kết quả',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} document${plural} sẽ khớp với nội dung',
  SearchDocuments_DocumentSummary:
    '${totalItems} document${plural} sẽ khớp với tiêu đề, số và mã',
  SearchDocuments_FolderSummary:
    '${totalItems} folder${plural} sẽ khớp với tiêu đề, số và mã',
  New: 'MỚI',
  Browse: 'Duyệt qua',
  ImportFolder_GlobalActionButton: 'Nhập cấu trúc thư mục',
  ImportFolder_Title: 'Nhập cấu trúc thư mục của bạn',
  ImportFolder_Step1_DragDropDescription1:
    'Kéo và thả hoặc duyệt tệp Excel để nhập thư mục.',
  ImportFolder_Step1_DragDropDescription2:
    'Lưu ý: Các thư mục bị vô hiệu hóa khi nhập.',
  ImportFolder_Step1_DragDropDescription3:
    'Định dạng file Excel của bạn với số thư mục là cột A và tên thư mục là cột B hoặc đơn giản là {0}',
  ImportFolder_Step1_FileUploaded: '{0} đã tải lên',
  ImportFolder_Step1_DownloadTemplateFile: 'Tải xuống mẫu excel',
  ImportFolder_Step1_Heading: 'Bạn đang nhập cấu trúc thư mục vào {0}',
  ImportFolder_Step1_ErrorMessage:
    'Tệp của bạn không được tải lên. Hãy thử lại với tệp .xls hoặc .xlsx.',
  ImportFolder_Step2_Title: 'Xem lại và hoàn tất quá trình nhập của bạn',
  ImportFolder_Step2_SuccessMessage: 'Thư mục của bạn đã được nhập.',
  Document_Preview: 'Xem trước tài liệu',
  FileUnsupportedForPreview: `We can’t show you a preview of this file.
    You’ll need to download the file to view the contents.`,
  ErrorWhileDownloadingFile:
    'Đã xảy ra lỗi khi cố tải xuống, vui lòng liên hệ với bộ phận Hỗ trợ khách hàng của chúng tôi bằng ${ErrorCode}',
  CannotDownloadingFile: 'Không thể tải tập tin.',
  ClickToSeeDetails: 'Bấm vào để xem chi tiết',
  TryAgain: 'Thử lại',
  NumberingUpdatedFor: 'Đánh số được cập nhật cho',
  Items: 'mặt hàng',
  YoureAboutToChangeTheNumberingOn: 'Bạn sắp thay đổi cách đánh số trên',
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    'Điều này có thể có tác động đến những người tham khảo tài liệu về dự án này.',
  AllDocuments: 'Tất cả tài liệu',
  AllQnaAndAttachments: 'Tất cả các câu hỏi và câu trả lời và tệp đính kèm',
  AllSubmissionDocuments: 'Tất cả hồ sơ nộp',
  AllEvaluationAttachments: 'Tất cả các tệp đính kèm đánh giá',
  AllUserActivityDocumentViewsReports:
    'Tất cả nhật ký hoạt động theo báo cáo lượt xem tài liệu và người',
  IncludeDocuments: 'Bao gồm tài liệu',
  IncludeSubmissionDocuments: 'Bao gồm tài liệu nộp',
  IncludeEvaluationAttachments: 'Bao gồm các tệp đính kèm đánh giá',
  IncludeQna: 'Bao gồm phần hỏi đáp',
  IncludeQnaAttachments: 'Bao gồm phần đính kèm Hỏi đáp',
  IncludeDisabledDocuments: 'Bao gồm các tài liệu bị vô hiệu hóa',
  Documents: 'Các tài liệu',
  SubmissionDocuments: 'Hồ sơ nộp',
  EvaluationAttachments: 'Đính kèm đánh giá',
  QnaAttachments: 'Tệp đính kèm hỏi đáp',
  DisabledDocuments: 'Tài liệu bị vô hiệu hóa',
  DocumentsVisibleTo: 'Tài liệu hiển thị cho',
  SubmissionDocumentsVisibleTo: 'Tài liệu đệ trình hiển thị cho',
  QnaAndAttachmentsVisibleTo: 'Hỏi đáp và các tệp đính kèm hiển thị với',
  QnaAttachmentsVisibleTo: 'Tệp đính kèm Hỏi &amp; Đáp hiển thị với',
  QnaVisibleTo: 'Hỏi đáp hiển thị với',
  IncludeDisabledDocumentsWarningMessage:
    'Việc bao gồm các tài liệu bị vô hiệu hóa sẽ tiết lộ các tài liệu hiện không hiển thị với nhóm đã chọn. Tùy chọn này không được khuyến khích.',
  AllSubTeams: 'Tất cả các đội phụ',
  AllSecurityGroups: 'Tất cả các nhóm bảo mật',
  NoSubTeams: 'Không có đội phụ',
  AdminOnlyFullArchive: 'Chỉ quản trị viên - lưu trữ đầy đủ',
  Team: 'Đội',
  SubTeam: 'Đội phụ',
  ArchiveName: 'Tên lưu trữ',
  Options: 'Tùy chọn',
  Summary: 'Bản tóm tắt',
  CreateArchive: 'Tạo kho lưu trữ',
  IncludeInArchive: 'Đưa vào Lưu trữ',
  VisibleTo: 'Hiển thị với',
  SubmissionDocuments_LowerCase: 'hồ sơ nộp',
  EvaluationAttachments_LowerCase: 'đính kèm đánh giá',
  Qna: 'Hỏi đáp',
  QnaAndAttachments_LowerCase: 'Tệp đính kèm hỏi đáp',
  DisableDocuments_LowerCase: 'tài liệu khuyết tật',
  Questions_LowerCase: 'câu hỏi',
  Attachments_LowerCase: 'tệp đính kèm',
  DocumentViewsReports_LowerCase: 'báo cáo lượt xem tài liệu',
  ActivityLogsByPerson_LowerCase: 'nhật ký hoạt động theo người',
  InProgress: 'Trong tiến trình',
  Expired: 'Hết hạn',
  Failed: 'Thất bại',
  YourArchiveIsBeingGenerated: 'Bản lưu trữ của bạn đang được tạo...',
  YourArchiveHasBeenQueued: 'Kho lưu trữ của bạn đã được xếp hàng đợi.',
  AnEmailWillBeSentTo: 'Một email sẽ được gửi đến',
  WithADownloadLinkWhenTheArchiveIsReady:
    'với liên kết tải xuống khi kho lưu trữ đã sẵn sàng.',
  ContactSupport: 'Liên hệ hỗ trợ',
  SomethingWentWrong: 'Đã xảy ra lỗi.',
  WeAreUnableToProcessYourArchiveRequest:
    'Chúng tôi không thể xử lý yêu cầu lưu trữ của bạn.',
  Retrieving: 'Đang truy xuất',
  FullArchiveAdminOnly: 'Bản lưu trữ đầy đủ - Chỉ dành cho quản trị viên',
  Filtered: 'Đã lọc',
  CreateYourFirstArchive: 'Tạo kho lưu trữ đầu tiên của bạn.',
  AutoTruncateHelpText:
    'Chúng tôi sẽ áp dụng cách cắt ngắn nhất để đảm bảo đường dẫn tệp không vượt quá 260 ký tự.',
  Becomes_LowerCase: 'trở thành',
  TruncationType: 'Kiểu cắt ngắn',
  AutoTruncate: 'Tự động cắt ngắn',
  DoNotTruncate: 'Đừng cắt ngắn',
  KeepLastSegmentOfNumbers: 'Giữ đoạn số cuối cùng',
  KeepNumbersOnly: 'Chỉ giữ số',
  KeepNamesOnly: 'Chỉ giữ tên',
  FullArchiveHelpText:
    'Quản trị viên Phòng dữ liệu có thể xem tất cả tài liệu và tệp đính kèm Hỏi đáp.',
  ArchiveHelpText:
    'Chúng tôi sẽ bao gồm ${includedOptions} hiển thị với ${teamOrSubTeamName}.',
  HowArchivesWork: 'Cách hoạt động của kho lưu trữ',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    'Kho lưu trữ chứa đường dẫn tệp đầy đủ cho mọi tài liệu được lưu trữ.',
  FilePathsAreLimitedTo260Characters:
    'Đường dẫn tệp được giới hạn ở 260 ký tự.',
  YouMayNeedToTruncateTheFilePaths:
    'Bạn có thể cần phải cắt bớt đường dẫn tệp để có thể xem chúng trên máy tính của mình.',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    'Ngoài ra, bạn có thể sử dụng ứng dụng ZIP để xem các kho lưu trữ có đường dẫn tệp dài.',
  YourArchiveIsDownloading: 'Kho lưu trữ của bạn đang tải xuống.',
  DoNotTruncateHelpText:
    'Bạn có thể sử dụng ứng dụng ZIP để trích xuất tài liệu có đường dẫn tệp dài.',
  Share: 'Chia sẻ',
  SecureShare_Capitalize: 'Chia sẻ an toàn',
  SecureShare_SentenceCase: 'Chia sẻ an toàn',
  ValidateEmailToView: 'Xác thực email để xem',
  ValidateEmailToViewDescription:
    'Mọi người sẽ cần xác thực địa chỉ email của họ trước khi xem tài liệu.',
  EnterPasscodeToView: 'Nhập mật mã để xem',
  EnterPasscodeToViewDescription:
    'Đặt mật mã để mọi người nhập trước khi họ có thể xem tài liệu.',
  AnyoneWithALinkCanView: 'Bất cứ ai có liên kết đều có thể xem',
  AnyoneWithALinkCanViewDescription:
    'Những người có liên kết sẽ có quyền truy cập không an toàn vào tài liệu.',
  NoAccess: 'Không truy cập',
  NoAccessDescription:
    'Những người có liên kết được chia sẻ không thể xem tài liệu được nữa.',
  SecureShareLinkSettings: 'Cài đặt quyền truy cập vào liên kết được chia sẻ',
  Watermark: 'Dấu mờ',
  LinkExpiresIn: 'Liên kết hết hạn sau ${duration} (${timezone})',
  LinkExpiredDuration:
    'Liên kết đã hết hạn ${duration} trước đây (${timezone})',
  LinkExpirationDate: 'Đặt ngày và giờ hết hạn liên kết',
  On: 'TRÊN',
  Off: 'Tắt',
  CreateWatermark: 'Tạo hình mờ',
  None: 'Không có',
  YouAreReadyToShare: 'Bạn đã sẵn sàng chia sẻ',
  WeHaveCopiedTheSecureShareLinkToYourClipboard:
    'Chúng tôi đã sao chép liên kết an toàn cho <strong data-ansarada-ccd="true">${fileName}</strong> vào khay nhớ tạm của bạn.',
  AnyoneWithTheLinkCanviewTheDocument:
    'Bất cứ ai có liên kết đều có thể xem tài liệu.',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    'Mọi người cần xác thực email của họ để xem tài liệu.',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    'Mọi người cần nhập mật mã ( <strong data-ansarada-ccd="true">${passCode}</strong> ) để xem tài liệu.',
  SecureShareLink: 'Liên kết chia sẻ an toàn',
  SecureShareLinkCopy: 'Liên kết an toàn để bạn sao chép và chia sẻ',
  SaveAndRemoveAccess_SentenceCase: 'Lưu và xóa quyền truy cập',
  AccessPasscode: 'Nhập mật mã để truy cập liên kết',
  SettingsSaved: 'Đã lưu cài đặt',
  WeHaveExpiredAllSecureShareLinks:
    'Chúng tôi đã hết hạn tất cả các liên kết Chia sẻ an toàn cho <strong data-ansarada-ccd="true">${fileName}</strong> .',
  LinkShareWithCode: 'Liên kết chia sẻ với mã',
  LinkShareWithEmail: 'Liên kết chia sẻ với email',
  LinkShare: 'Liên kết chia sẻ',
  AllDownloadedCopiesWillSelfDestruct:
    'Tất cả các bản sao đã tải xuống sẽ tự hủy.',
  NeedHelpSharingALinkOrDocument:
    'Cần trợ giúp chia sẻ liên kết hoặc tài liệu?',
  HowDoIExpireAllLinksToADocument:
    'Làm cách nào để hết hạn tất cả các liên kết tới một tài liệu?',
  WhatDoIDoToDenyADownload: 'Tôi phải làm gì để từ chối tải xuống?',
  FindOutMoreAboutSecureShare:
    'Tìm hiểu thêm về cách chia sẻ tài liệu một cách an toàn',
  SaveAndCopyLink_SentenceCase: 'Lưu và sao chép liên kết',
  ShareDocumentSecurely_SentenceCase: 'Chia sẻ tài liệu một cách an toàn',
  ShareDocumentEmptyStateDescription:
    'Chọn một tài liệu từ cột quản lý tài liệu để bắt đầu chia sẻ.',
  FirstTellUsWhoYouAre: 'Đầu tiên, hãy cho chúng tôi biết bạn là ai',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    'Để truy cập tài liệu được chia sẻ, chúng tôi cần xác minh địa chỉ email của bạn.',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    'Chúng tôi sẽ gửi cho bạn một email để bạn có thể truy cập tài liệu được chia sẻ.',
  EnterAnEmailAddress: 'Nhập địa chỉ email',
  EnterAValidEmailAddress: 'Nhập địa chỉ email hợp lệ',
  EmailIsRequired: 'Email thì cần thiết',
  VerifyMyEmail_SentenceCase: 'Xác minh email của tôi',
  FirstEnterThePasscode: 'Đầu tiên, nhập mật mã',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    'Để truy cập tài liệu được chia sẻ, bạn cần nhập mật mã.',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    'Hãy liên hệ với người đã chia sẻ liên kết với bạn để tìm hiểu thêm.',
  EnterTheAccessPasscode: 'Nhập mật mã truy cập',
  ViewDocument_SentenceCase: 'Xem tài liệu',
  TheDocumentIsNoLongerAvailable: 'Tài liệu này không còn nữa',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    'Quyền truy cập của bạn có thể đã bị xóa hoặc tài liệu đã bị xóa.',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    'Hãy liên hệ với người đã chia sẻ liên kết với bạn để tìm hiểu thêm.',
  SecurityControlsOn: 'Kiểm soát an ninh bật',
  SecurityControlsOff: 'Kiểm soát an ninh tắt',
  CopyingAllowed: 'Cho phép sao chép',
  CopyingDenied: 'Sao chép bị từ chối',
  EditingAllowed: 'Cho phép chỉnh sửa',
  EditingDenied: 'Chỉnh sửa bị từ chối',
  DenyCopyingDisabled: 'Từ chối sao chép bị vô hiệu hóa',
  DenyEditingDisabled: 'Từ chối chỉnh sửa bị vô hiệu hóa',
  DenyPrintingDisabled: 'Từ chối in bị vô hiệu hóa',
  DenySavingDisabled: 'Từ chối lưu bị vô hiệu hóa',
  Redirecting: 'Đang chuyển hướng...',
  CheckYourInbox: 'Kiểm tra hộp thư của bạn',
  YouAreOnADifferentDevice: 'Bạn đang sử dụng một thiết bị khác',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    'Bạn chỉ có thể xem tài liệu này từ cùng một thiết bị được sử dụng để xác minh email của bạn.',
  WeHaveSentAnEmailToYourEmail: 'Chúng tôi đã gửi email tới',
  WithTheAccessToViewTheDocument: 'với quyền truy cập để xem tài liệu.',
  ViewActivity: 'Xem hoạt động',
  PasscodeIsNotCorrect: 'Mật mã không đúng',
  SubmissionDocumentUploaded: '1 tài liệu được tải lên để gửi.',
  SubmissionDocumentsUploaded:
    'Tài liệu ${NumberOfDocuments} được tải lên để gửi.',
  HowSubmissionsWork: 'Cách thức hoạt động của việc gửi',
  AllAddedDocumentsAreAutomaticallySubmitted:
    'Tất cả các tài liệu được thêm vào sẽ được gửi tự động.',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    'Bạn có thời gian cho đến khi đóng cửa sổ gửi để thực hiện thay đổi.',
  UntilClose: 'cho đến khi đóng',
  Ansarada: 'Ansarada',
  BulkEditFileUpload: `or drag and drop your refined Excel here. We'll present a crisp
  overview of the edits.`,
  BulkEditFileUploadAfterUploading:
    'hoặc kéo và thả đúng file vào đây để chuyển đổi liền mạch.',
  BulkEditExcelReady:
    'Đúng, ${name}! Excel đã chỉnh sửa của bạn đã sẵn sàng chưa?',
  BeforeYourEdits: 'Trước khi bạn chỉnh sửa',
  AfterYourEdits: 'Sau khi chỉnh sửa của bạn',
  DropFilesHereToAttach: 'Thả tập tin vào đây để đính kèm',
  KickOffBy: 'Khởi đầu bởi',
  DownloadingTheExcelVersion: 'tải xuống phiên bản Excel',
  OfYourDocumentIndex: 'của Chỉ mục Tài liệu của bạn.',
  BulkEditNextButtonGuide:
    'Sau khi tinh chỉnh, chạm vào nút <strong>Tiếp theo</strong> để tải lên và chứng kiến hiệu quả hoạt động.',
  BulkEditDownloadExcelFileHeading:
    'Nâng cao quy trình làm việc của bạn: Chỉnh sửa tài liệu một cách liền mạch.',
  BulkEditAllSetHeading: 'Đã hoàn tất, ${name}! Bạn đã sẵn sàng hành động.',
  BulkEditButtonGuide:
    'Sau khi bạn nhấn nút <strong>Chỉnh sửa hàng loạt</strong> , chúng tôi sẽ sẵn sàng điều chỉnh ${combinedText} theo chỉ thị của bạn.',
  HeadsUpThough: `<strong>Just a heads-up:</strong> We won’t apply at least one edit. The administrators removed them from the Document Index.`,
  ProTip: 'Một mẹo chuyên nghiệp?',
  ProTipDescription:
    'Hãy cân nhắc việc tải xuống phiên bản Excel mới nhất của Chỉ mục Tài liệu của bạn. Nó sẽ cung cấp cho bạn ảnh chụp nhanh nguyên bản trước khi bắt đầu chỉnh sửa.',
  GrabItHere: 'Lấy nó ở đây.',
  BulkEditSuccessMessage: `Your bulk update is applied and now in the Document Index. We've got your back!`,
  NotTheRightExcel: 'Không phải là Excel phù hợp?',
  UploadFailedMessage:
    'Tải lên không thành công, ${name}. Đã xảy ra sự cố khi tải lên. Vui lòng thử lại.',
  FailedMessage:
    'Cập nhật không thành công, ${name}. Đã xảy ra sự cố với bản cập nhật hàng loạt. Vui lòng thử lại.',
  DoNotHaveAccessMessage:
    'Bạn không có quyền truy cập vào một số tài liệu và thư mục đã thay đổi trong Excel được cung cấp, vui lòng yêu cầu quản trị viên Phòng Dữ liệu thực hiện thao tác',
};
